import { schMcKissockAccountData, schUSPhoneNumber, schZipCode } from '@aloft/toolkit-shared';

import { z } from 'zod';

const schNonEmptyString = z.string().trim().min(1);

export const schOnboardingForm = z.strictObject({
  version: z.literal(1),
  firstName: schNonEmptyString,
  lastName: schNonEmptyString,
  phone: schUSPhoneNumber,
  address: z.strictObject({
    PostalCode: schZipCode,
  }),
  mcKissockData: schMcKissockAccountData.or(z.undefined()),
});

export const REFERRED_BY_PARAM_KEY = 'referred_by';
export const MCKISSOCK_PARAM_KEY = 'mckissock';
